import _ from 'lodash';
import cache from '../common/cache';

const CACHE_KEY_PREFIX = 'VUP_CAMPAIGN_USER_TARGETED';
export const CACHE_EXPIRY_MS = 60 * 60 * 1000;

export default class CampaignUserTargeting {
  constructor(collection, api) {
    this.api = api;
    this.campaignUserTargeted = {};

    _.forEach(collection.slots, (slot) => {
      _.forEach(slot.slotCampaigns, (campaignItem) => {
        const {campaign} = campaignItem;
        if (campaign && !campaign.isTargeted) {
          this.campaignUserTargeted[campaign.id] = true;
        }
      });
    });
  }

  checkUserTargeted(campaignId) {
    if (!campaignId) {
      return Promise.resolve(true);
    }

    if (_.has(this.campaignUserTargeted, campaignId)) {
      return Promise.resolve(this.campaignUserTargeted[campaignId]);
    }

    const cachedResponse = this.getFromCache(campaignId);
    if (cachedResponse && _.has(cachedResponse, 'isUserTargeted')) {
      return cachedResponse.isUserTargeted;
    }

    this.campaignUserTargeted[campaignId] = this.api.checkCampaignUserTargeting(campaignId)
      .then((res) => {
        this.campaignUserTargeted[campaignId] = res.isUserTargeted;
        this.setInCache(campaignId, res);
        return res.isUserTargeted;
      })
      .catch(() => false);

    return this.campaignUserTargeted[campaignId];
  }

  getFromCache(campaignId) {
    return cache.get(`${CACHE_KEY_PREFIX}_${campaignId}`);
  }

  setInCache(campaignId, res) {
    cache.set(`${CACHE_KEY_PREFIX}_${campaignId}`, res, new Date().getTime() + CACHE_EXPIRY_MS);
  }
}
